<template>
    <div class="vx-popup-suggest">
        <vx-input
            ref="input"
            v-bind="$attrs"
            :placeholder="placeholder"
            :label="label"
            :value="valueDisplayText"
            :icon="icon"
            :disabled="disabled"
            @input="vxInputReceived"
            @focus.stop.prevent="open"
        />
        <vx-overlay :active.sync="focused" center-content>
            <elastic-suggest
                ref="elasticSuggest"
                v-on="$listeners"
                v-bind="$attrs"
                :icon="icon"
                :search_groups="search_groups"
                :placeholder="placeholder"
                :clearable="false"
                class="w-1/3"
                select-like
                show-on-focus
                style="margin-top: -8rem"
                @input="close"
            >
                <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
                <!-- Pass on all scoped slots -->
                <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
                    <slot :name="slot" v-bind="scope" />
                </template>
            </elastic-suggest>
        </vx-overlay>
    </div>
</template>

<script>
export default {
    name: 'VxPopupSuggest',
    props: {
        value: {
            type: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null
        },
        search_groups: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String
        },
        icon: {
            type: String,
            default: 'SearchIcon'
        }
    },
    data() {
        return {
            focused: false
        }
    },
    computed: {
        firstGroup() {
            var grp_name = Object.keys(this.search_groups).first()
            return this.search_groups[grp_name]
        },
        getDisplayText() {
            var displayText = this.firstGroup.displayText
            if (!displayText) {
                return this.getSearchText
            }
            var displayTextType = typeof displayText
            // returns the relevant accessor to a provided object to retrieve the text
            if (displayTextType === 'function') {
                return displayText
            }
            return (v) => v && v[displayText]
        },
        getSearchText() {
            var searchText = this.firstGroup.searchOn
            var searchTextType = typeof searchText
            // returns the relevant accessor to a provided object to retrieve the text
            if (searchTextType === 'function') {
                return searchText
            }
            if (searchTextType === 'string') {
                return (v) => v && v[searchText]
            }
            return (v) => v
        },
        valueDisplayText() {
            return this.getDisplayText(this.value)
        }
    },
    methods: {
        vxInputReceived(v) {
            if (!v) {
                this.$emit('input', null)
            }
        },
        close() {
            this.focused = false
        },
        inputReceived(v) {
            if (!v) {
                return
            }
            this.close()
        },
        focus() {
            this.$refs.input && this.$refs.input.focus()
        },
        open() {
            this.focused = true
            setTimeout(() => {
                this.$refs.elasticSuggest.focus()
            }, 100)
        }
    }
}
</script>

<style lang="scss" scoped></style>
